export const translations = {
  is: {
    RoundTitles: {
      Ö1L1: "Ökunámsferlið",
      Ö1L2: "Bíll og búnaður",
      Ö1L3: "Umferðarheild",
      Ö1L4: "Umferðarreglur",
      Ö1L5: "Viðhorf gagnvart umferðinni",
      Ö1L6: "Umferðarskilti",
      Ö2L1: "Upprifjun á Ökuskóla 1",
      Ö2L2: "Umferðarsálfræði",
      Ö2L3: "Áhættuþættir umferðarinnar",
      Ö2L4: "Ábyrgð ökumannsins",
      Ö2L5: "Opinber viðurlög við brotum",
      Ö2L6: "Slys og skyndihjálp",
    },
  },
  en: {
    RoundTitles: {
      Ö1L1: "Learning to drive",
      Ö1L2: "Cars and their equipment",
      Ö1L3: "Traffic as a whole",
      Ö1L4: "Traffic laws",
      Ö1L5: "Behaving in traffic",
      Ö1L6: "Traffic signs",
      Ö2L1: "Driving School 1 Revision",
      Ö2L2: "Traffic psychology",
      Ö2L3: "Traffic risk factors",
      Ö2L4: "The driver's responsibility",
      Ö2L5: "Penalties for traffic violations",
      Ö2L6: "Accidents and first-aid",
    },
  },
};
